/* eslint-disable @typescript-eslint/no-unused-vars */

const styleHistory = { documentElement: {}, body: {} };

export const styleTargets = Object.freeze({
    // html
    documentElement: {
        overflow: 'auto',
        height: '100%',
        'scrollbar-gutter': 'stable',
    },
    body: {
        overflow: 'hidden',
        position: 'relative',
        height: '100%',
        'scrollbar-gutter': 'stable',
    },
});

const setStyle =
    (target) =>
    ([k, v]) => {
        styleHistory[target][k] = document[target].style[k];
    };

export const setStyles = () =>
    Object.entries(styleTargets).forEach(([target, styles]) => {
        Object.entries(styles).forEach(setStyle(target));
    });

const resetStyle =
    (target) =>
    ([k, _]) => {
        document[target].style[k] = styleHistory[target][k];
    };

export const resetStyles = () =>
    Object.entries(styleHistory).forEach(([target, styles]) => {
        Object.entries(styles).forEach(resetStyle(target));
    });
